import { styled } from '@mui/material';
import TransparentPopover from '../utils/TransparentPopover';

const StyledPopover = styled(TransparentPopover)({
  '& .MuiPaper-root': {
    padding: '4px 8px',
  },
});

export default StyledPopover;
